export const getNonDuplicatedMessages = (messages, newMessage) => {
  if (messages.some(m => m.type === newMessage.type && m.text === newMessage.text)) return messages;
  return [...messages, newMessage];
};